import React from 'react';
import styled from 'styled-components';
import SectionHeader from '../SectionHeader';
import { RequiredStar } from '../../styled';
export const Container = styled.div `
  position: relative;
  height: 100%;

  @media (max-width: 991px) {
    padding-bottom: 75px;
  }
`;
export const Header = styled.div `
  margin-top: 10px;
  margin-bottom: 5px;
  line-height: 18px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: ${(props) => props.theme.fontXXSmall};
  color: ${(props) => props.theme.navyBlue};
  ${(props) => props.showHighLight && `background-color: #fefaf2;`}
  span {
    font-weight: ${(props) => props.theme.normal};
  }
`;
export const Text = styled.div `
  padding: 16px 15px 16px 0;
  font-size: ${(props) => props.theme.fontXXSmall};
  line-height: 21px;
  color: ${(props) => props.theme.navyBlue};
  border-bottom: 1px solid ${(props) => props.theme.athensGray};
`;
export const TextArea = styled.textarea `
  width: 100%;
  overflow: auto;
  border: 1px solid ${(props) => props.theme.ghostWhite};
  border-bottom: 2px solid ${(props) => props.theme.iron};
  background: ${(props) => props.theme.ghostWhite};
  padding: 10px;
  font-size: ${(props) => props.theme.fontXXSmall};
  line-height: 15px;
  color: ${(props) => props.theme.navyBlue};
  outline: none;
  min-height: 75px;
  max-height: calc(100% - 290px);
`;
const RejectPanel = ({ comment, headerText, messageText, commentText, showHighLight, onChange, commentRef, required, }) => {
    return (React.createElement("div", { className: "row", ref: commentRef },
        React.createElement(SectionHeader, { text: headerText }),
        React.createElement(Container, { className: "col-12" },
            React.createElement(Text, null, messageText),
            React.createElement(Header, { showHighLight: showHighLight && !comment },
                required && React.createElement(RequiredStar, null),
                commentText),
            React.createElement(TextArea, { id: "comment", maxLength: 10000, value: comment, onChange: (event) => onChange(event.target.value) }))));
};
RejectPanel.defaultProps = {
    required: true,
};
export default RejectPanel;
